import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import filterContainer from '@components/ui-components/filter-container/filter-container.vue'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      promotionsSwiperOption: {
        spaceBetween: 32,
        parallax: true,
        speed: 700,
        loop: true,
        autoplay: {
          delay: 8000,
        },
        pagination: {
          el: '.js-promotions-pag',
          clickable: true,
        },
      },
    }
  },
  components: {
    'filter-container-cmp': filterContainer,
  },
  beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '')
    this.$root.setDataAnimateFalse()

    Vue.http.get(`templates${path}`, { params: to.query }).then(
      data => {
        next()
        setTimeout(() => {
          this.template = data.data
          onScrollAnimate()
          if (this.$refs.promotionSwiper) {
            this.$refs.promotionSwiper.swiper.update()
          }
        }, 500)
      },
      () => {
        next('/404')
      }
    )
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/promotions/index.js